var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",{"transform":"translate(-207 -1203) translate(207 1203)"},[React.createElement("circle",{"cx":"31.5","cy":"31.5","r":"31.5","fill":"#E88816","key":0}),React.createElement("path",{"fill":"#FFF","d":"M27 23L41 32 27 41z","key":1})]))));
}

Play.defaultProps = {"width":"63","height":"63","viewBox":"0 0 63 63"};

module.exports = Play;

Play.default = Play;
